<script>
  export let src;
  export let alt;
</script>

<div class="contact-item">
  <img {src} {alt}>
  <slot></slot>
</div>